import api, { clearDocsCookie } from "./axios";

/**
 * Single logout path for the whole app.
 * - Snapshots the stored tokens, then clears local session state immediately
 *   (access_token, refresh_token, user, docs cookie) so the UI never waits on
 *   the network.
 * - Best-effort POST /auth/logout to revoke the refresh token server-side;
 *   any error (offline, expired access token, ...) is ignored.
 */
export const logoutSession = async (): Promise<void> => {
  const accessToken = window.localStorage.getItem("access_token");
  const refreshToken = window.localStorage.getItem("refresh_token");

  window.localStorage.removeItem("access_token");
  window.localStorage.removeItem("refresh_token");
  window.localStorage.removeItem("user");
  clearDocsCookie();

  if (!accessToken) return;
  try {
    await api.post(
      "/auth/logout",
      refreshToken ? { refreshToken } : {},
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
  } catch {
    // best-effort — local session is already cleared
  }
};
